// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Use environment variables to support both custom domain and default Supabase URL
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://bhueeqantvudmtlfmzti.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJodWVlcWFudHZ1ZG10bGZtenRpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYwMTM2MzgsImV4cCI6MjA1MTU4OTYzOH0.RKydrIDj-a4U02eQfLjMvsku6N07S1PIbUw4HRYBsoE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);